import React from 'react';
import * as S from './secret-toggle.styles';
import {SecretToggleButton, SecretToggleButtonContainer} from "./secret-toggle.styles";

interface ISecretToggleProps {
    children?: React.ReactNode;
}

export const SecretToggle: React.FunctionComponent<ISecretToggleProps> = (props: ISecretToggleProps): React.ReactElement => {
    const [enabled, setEnabled] = React.useState(false);

    const handleClick = (): void => {
        if(!enabled) {
            setEnabled(true);
        }
    };

    return (
        <>
            <S.SecretToggle enabled={enabled} onClick={handleClick}>
                {enabled ? props.children : '********-****-****-****-************'}
            </S.SecretToggle>
            <S.SecretToggleButtonContainer enabled={enabled} onClick={handleClick}>
                <S.SecretToggleButton>Show Secret</S.SecretToggleButton>
            </S.SecretToggleButtonContainer>
        </>
    );
};
